import { createApiActions } from '@ackee/redux-utils';
import { actionType } from '../../../../../services/utils';
const ACTION_TYPE = actionType('REFRESH_TOKENS');
/**
 * @ignore
 */

export const refreshTokens = createApiActions(ACTION_TYPE);